require([
	'jquery',
	'root/Base/Js/MbiImageSize',
	'root/Base/Js/MbiMediaQuery',
	'flickity'
], function(
	$,
	mbiImageSize,
	mbiMq,
	flickity
	) {

	'use strict';

	var imageSliders = [];

	if ($('.fullwidth-slider').length > 0) {
		$('.fullwidth-slider').each(function(index) {
			imageSliders[index] = new flickity(this, {
				cellSelector: '.slide',
				pageDots: true,
				wrapAround: true,
				prevNextButtons: true,
				watchCSS: false,
				dragThreshold: 20,
				arrowShape: {
					x0: 0,
					x1: 50,
					y1: 50,
					x2: 5,
					y2: 0,
					x3: 100
				}
			});
		});
	}

});
define("root/Assets/Templates/Html/FullwidthSlider/Js/FullwidthSlider", function(){});

